module.exports = __webpack_public_path__ + "img/pattern-tile-2.0c26058e.png";